import { TaskCategoryTaskType } from '@urbanx/agx.activities.client'
import AgreementDetails from './AgreementDetails/AgreementDetails'
import { BaseComplianceModalProps } from 'pages/allTasks/ComplianceModal/BaseComplianceModalProps'
import AgreementComplianceTypePage from './AgreementComplianceType/AgreementComplianceTypePage'
import AgreementCommissionPage from './AgreementCommission/AgreementCommissionPage'

const CompliancePages = (props: BaseComplianceModalProps) => {
  const taskType = props.task.category?.taskType

  switch (taskType) {
    case TaskCategoryTaskType.AgreementDetails:
      return <AgreementDetails {...props} />
    case TaskCategoryTaskType.AgreementComplianceType:
      return <AgreementComplianceTypePage {...props} />
    case TaskCategoryTaskType.AgreementCommission:
      return <AgreementCommissionPage {...props} />
    default:
      return <div>Unknown Task Type</div>
  }
}

export default CompliancePages
